module.exports = __webpack_public_path__ + "static/media/Alitas caseras.d96e7eef.webp";